module.exports = __webpack_public_path__ + "media/images/amenities_icons/microphone-9e0903072723587f8310d0f43e0abd80.svg";